<template>
  <div class="TextField">
    <div class="TextField__inner">
      <input
        v-if="isPassword"
        :id="id"
        class="TextField__form"
        :class="{
          [`TextField__form--error`]: isError,
          [`TextField__form--password`]: isPassword,
        }"
        :type="inputType"
        :name="name"
        :aria-label="ariaLabel"
        :placeholder="placeholder"
        :disabled="isDisabled"
        :value="value"
        @input="$emit('input', $event.target.value)"
      />
      <input
        v-else-if="inputTypeSelect"
        :id="id"
        class="TextField__form"
        :class="{ [`TextField__form--error`]: isError }"
        :type="inputTypeSelect"
        :name="name"
        :aria-label="ariaLabel"
        :placeholder="placeholder"
        :disabled="isDisabled"
        :value="value"
        @input="$emit('input', $event.target.value)"
      />
      <input
        v-else
        :id="id"
        class="TextField__form"
        :class="{
          [`TextField__form--error`]: isError,
        }"
        :type="type"
        :name="name"
        :value="value"
        :aria-label="ariaLabel"
        :placeholder="placeholder"
        :disabled="isDisabled"
        :min="min"
        :max="max"
        @input="onInput"
        @blur="onBlur"
      />
      <Icon
        v-if="isPassword"
        class="TextField__icon"
        :icon-name="passwordIcon ? 'PasswordOn' : 'PasswordOff'"
        @click="onClick"
      />
    </div>
    <span v-if="isError && errorText !== ''" class="TextField__errorText">{{
      errorText
    }}</span>
  </div>
</template>

<script>
import Icon from '@spectee/components/Atoms/IconBase/index.vue';

export default {
  name: 'TextField',
  components: { Icon },
  props: {
    type: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
    },
    isError: {
      type: Boolean,
    },
    isPassword: {
      type: Boolean,
    },
    errorText: {
      type: String,
      default: '',
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
    inputTypeSelect: {
      type: Function,
      default: null,
    },
  },
  emits: ['input', 'blur'],
  data() {
    return {
      passwordIcon: false,
    };
  },
  computed: {
    inputType() {
      return this.passwordIcon ? 'text' : 'password';
    },
  },
  methods: {
    onClick() {
      this.passwordIcon = !this.passwordIcon;
    },
    onInput(e) {
      this.$emit('input', e);
    },
    onBlur(e) {
      this.$emit('blur', e);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.TextField {
  &__form {
    display: flex;
    width: 100%;
    height: $service-unit * 10;
    padding: 0 $service-unit * 4;
    font-size: $service-font-size-p;
    color: $color-gray-80;
    background-color: $color-white-100;
    border: 1px solid $color-gray-50;
    border-radius: $service-border-radius;
    caret-color: $color-blue-60;

    &::placeholder {
      color: $color-gray-50;
    }

    &:hover {
      border: 1px solid $color-blue-60;
    }

    &:focus {
      outline: 2px solid $color-blue-60;
    }

    &:disabled {
      background-color: $color-gray-30;
      border: 0;
    }

    &--error {
      border: 2px solid $color-red-70;

      &:hover {
        border: 2px solid $color-red-70;
      }
    }

    &--password {
      padding: 0 $service-unit * 11 0 $service-unit * 4;
    }
  }

  &__inner {
    position: relative;
  }

  & &__icon {
    position: absolute;
    top: 50%;
    right: $service-unit * 4;
    width: $service-unit * 6;
    height: $service-unit * 6;
    color: $color-gray-50;
    cursor: pointer;
    transform: translateY(-50%);
  }

  &__errorText {
    display: block;
    margin-top: $service-unit;
    font-size: $service-font-size-pp;
    color: $color-red-70;
    text-align: left;
  }
}
</style>
